// extracted by mini-css-extract-plugin
export var item = "landing-item-module--item--JeMeW";
export var itemIcon = "landing-item-module--item-icon--s8ock";
export var web = "landing-item-module--web--29a9i";
export var code = "landing-item-module--code--bEc3x";
export var coin = "landing-item-module--coin--+uj8q";
export var time = "landing-item-module--time--Cvmtx";
export var title = "landing-item-module--title--blzP2";